import React from 'react';
import {
  GmailMail,
  ICloudMail,
  MailruMail,
  OutlookMail,
  RamblerMail,
  YandexMail,
} from '@lt/components/icons-react/auth';

import { i18n } from '@lt/localization';
import type { ProviderConfig } from './types';
import { EmailProvider } from './types';

export const mapProviderToConfig: Record<EmailProvider, ProviderConfig> = {
  [EmailProvider.Gmail]: {
    icon: <GmailMail width={25} height={25} />,
    name: i18n.t('emailButton.emailProvider.name', {
      ns: 'auth',
      context: 'gmail',
    }),
    url: 'https://mail.google.com/',
  },
  [EmailProvider.Yandex]: {
    icon: <YandexMail width={25} height={25} />,
    name: i18n.t('emailButton.emailProvider.name', {
      ns: 'auth',
      context: 'yandex',
    }),
    url: 'https://mail.yandex.ru/',
  },
  [EmailProvider.Mail]: {
    icon: <MailruMail width={25} height={25} />,
    name: i18n.t('emailButton.emailProvider.name', {
      ns: 'auth',
      context: 'mail',
    }),
    url: 'https://mail.ru/',
  },
  [EmailProvider.Rambler]: {
    icon: <RamblerMail width={25} height={25} />,
    name: i18n.t('emailButton.emailProvider.name', {
      ns: 'auth',
      context: 'rambler',
    }),
    url: 'https://mail.rambler.ru/',
  },
  [EmailProvider.ICloud]: {
    icon: <ICloudMail width={25} height={25} />,
    name: i18n.t('emailButton.emailProvider.name', {
      ns: 'auth',
      context: 'icloud',
    }),
    url: 'https://www.icloud.com/mail',
  },
  [EmailProvider.Outlook]: {
    icon: <OutlookMail width={25} height={25} />,
    name: i18n.t('emailButton.emailProvider.name', {
      ns: 'auth',
      context: 'outlook',
    }),
    url: 'https://outlook.live.com/',
  },
};
